// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2p-7D","select":"Header_select__2CNbO","clinic":"Header_clinic__wj6QE"};